import Vue                                from "vue";
import { mapGetters }                     from "vuex";
import { 
    EntitlementsService,
    DealerUtil
 }              from "@/services/";
import { formatDateTime, stringHelper }   from "@/components/mixins";
import { AvailableDealerCodeSelector }    from "@/components/Dropdowns";
import { LoadingSpinner }                   from "@/components";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default Vue.extend({
    name: "OpenCoreCreditRequests",
    components: {
        AvailableDealerCodeSelector,
        LoadingSpinner,
        DnTable
    },
    mixins: [formatDateTime, stringHelper],

    created() {
        const dealerCodes = this.availableDealerCodes || [];
        const user = this.user;
        this.currentDealerSelection = DealerUtil.determineCurrentDealerSelection(
            dealerCodes,
            user,
            this.hasAccessToAllBranches
        );

        this.loadOpenCcrs()        
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem",
            "availableDealerCodes",
            "activeAccountId"
        ]),
        hasAccessToAllBranches() {
            return (
              this.availableDealerCodes.length > 1 && this.user.DealerRange !== "*"
            );
        },
        filteredOpenCcrs(){ 
            if(this.currentDealerSelection.value === "All Branches"){
                return this.openCcrs
            }                 
            let filteredCcrs = Array.from(this.openCcrs).filter((x:any) => {
                return x.DealerCode === this.currentDealerSelection.PrimaryDealerCode
            })
            
            return filteredCcrs 
        },
        haveLoadedAllCcrs(){
            let minimumAccountsLoaded = 1
            
            if( !this.currentDealerSelection.AccountId){
                // Only do this for "All Branches"
                minimumAccountsLoaded = this.availableDealerCodes.length;
            }            

            return this.numberOfAccountIdsFetchedFromCCRs >= minimumAccountsLoaded;
        }
    },
    data: () => ({
        currentDealerSelection: null,
        openCcrs: [],
        openCcrsDataColumns:[
            {key: "Number", label: "CCR Number", sortable: true },
            {key: "DealerCode", label: "Dealer Code", sortable: true },
            { key: "Ccr.ExpectedShipDate", label: "Estimated Ship Date", sortable: true, formatter: "formatDateTime" },
            { key: "Ccr.CreatedDate", label: "Created Date", sortable: true, formatter: "formatDateTime" },

        ],
        numberOfAccountIdsFetchedFromCCRs: 0
    }),
    methods: {
        loadOpenCcrs(){
            if(this.currentDealerSelection.AccountId){
                this.getOpenCcrs(this.currentDealerSelection.AccountId);
            }
            else{
                let allAccountIds = this.availableDealerCodes.map(x => x.AccountId)
                allAccountIds.forEach(x => this.getOpenCcrs(x))
            }
        },
        getOpenCcrs(accountId){
            let requestParams = {
                AccountId: accountId,
                PriorDaysToSearch: 400,
                OrderByField: "ModifiedDate",
                OrderByDirection: "DESC",
                OpenCcrsOnly: true,
                PageNumber: 1,
                PageSize: 50
               } 
                
               EntitlementsService.GetCoreCreditRequests(requestParams)
               .then(response =>{
                   this.openCcrs = _.concat(this.openCcrs, response.data);
               })
               .finally(() => {
                   this.numberOfAccountIdsFetchedFromCCRs += 1;
               })
               .catch(() => {
                this.$store.commit("pushTimedMessage", {
                    header: "An error occurred retrieving your open CCRs.",
                    IsError: true
                  })
            });             
        },
        setSelectedDealerCode(selectedDealer:any) {
            this.currentDealerSelection = selectedDealer
            this.getOpenCcrs(selectedDealer.AccountId)
        },
    },
    watch: {
    },
});
